export default __webpack_public_path__ + "static/media/undraw_Design_sprint_re_tke3.b2e72d96.svg";